// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DisplayBookOfMindQuote__quoteRow___L2_jR {
    position: relative;
    margin: 0 4px;
    padding-bottom: 0;
    border-radius: 4px;
}

.DisplayBookOfMindQuote__quoteRow___L2_jR::before {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 0;
    border-radius: inherit;
    pointer-events: none;
    opacity: 0;
    background: linear-gradient(
        to right,
        rgba(151, 111, 46, 0.03),
        rgba(151, 111, 46, 0.14) 14%,
        rgba(151, 111, 46, 0.14) 86%,
        rgba(151, 111, 46, 0.03)
    );
    box-shadow: inset 0 0 0 1px rgba(177, 136, 64, 0.12);
    mask-image: linear-gradient(
        to bottom,
        transparent 0,
        black 10px,
        black calc(100% - 10px),
        transparent 100%
    );
    -webkit-mask-image: linear-gradient(
        to bottom,
        transparent 0,
        black 10px,
        black calc(100% - 10px),
        transparent 100%
    );
    transition: opacity 150ms ease;
}

.DisplayBookOfMindQuote__quoteLink___bt5ja {
    display: block;
    padding: 1px 0;
    position: relative;
    border-radius: 4px;
    text-shadow: none;
    transition: text-shadow 150ms ease;
}

.DisplayBookOfMindQuote__quote___Ds4Jl {
    position: relative;
    z-index: 1;
    transition: opacity 150ms ease, text-shadow 150ms ease;
}

.DisplayBookOfMindQuote__wordReveal___Lg4Hk {
    opacity: 0;
    animation: DisplayBookOfMindQuote__bookOfMindWordReveal___vR75d 420ms ease-out both;
}

@keyframes DisplayBookOfMindQuote__bookOfMindWordReveal___vR75d {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@media (hover: hover) {
    .DisplayBookOfMindQuote__quoteRevealComplete___Dmnk0:hover .DisplayBookOfMindQuote__quote___Ds4Jl {
        opacity: 1;
        text-shadow: 0 0 5px gold;
    }

    .DisplayBookOfMindQuote__quoteLink___bt5ja:hover {
        text-shadow: none;
    }

    .DisplayBookOfMindQuote__quoteRevealComplete___Dmnk0:hover::before {
        opacity: 1;
    }
}

.DisplayBookOfMindQuote__selectedQuoteRow___IVBlU::before {
    opacity: 1;
}

.DisplayBookOfMindQuote__selectedQuoteRow___IVBlU {
    padding-bottom: 6px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"quoteRow": `DisplayBookOfMindQuote__quoteRow___L2_jR`,
	"quoteLink": `DisplayBookOfMindQuote__quoteLink___bt5ja`,
	"quote": `DisplayBookOfMindQuote__quote___Ds4Jl`,
	"wordReveal": `DisplayBookOfMindQuote__wordReveal___Lg4Hk`,
	"bookOfMindWordReveal": `DisplayBookOfMindQuote__bookOfMindWordReveal___vR75d`,
	"quoteRevealComplete": `DisplayBookOfMindQuote__quoteRevealComplete___Dmnk0`,
	"selectedQuoteRow": `DisplayBookOfMindQuote__selectedQuoteRow___IVBlU`
};
module.exports = ___CSS_LOADER_EXPORT___;
